import React from "react";
import "../css/Common.css";
import "../css/GrievanceRedressalMechanism.css";

const escalationLevels = [
  {
    level: "First Escalation",
    department: "Customer care",
    contacts: [
      { label: "Phone", value: "+91 8750238443", href: "tel:+918750238443" },
      { label: "Email", value: "care@snappaisa.com", href: "mailto:care@snappaisa.com" },
    ],
    resolution:
      "If the issue is not resolved within 7 days of raising the issue, the customer shall raise the issue with the Grievance Officer",
  },
  {
    level: "Second Escalation",
    department: "Grievance Officer",
    contacts: [
      { label: "Name", value: "Mr. Kurendar Kumar" },
      { label: "Phone", value: "+91 8750118617", href: "tel:+918750118617" },
      { label: "Email", value: "grievance@ampirefinance.com", href: "mailto:grievance@ampirefinance.com" },
    ],
    resolution:
      "If the issue is not resolved within 7 days of raising the issue, the customer shall raise the further issue with the Nodal Officer",
  },
  {
    level: "Third Escalation",
    department: "Nodal Officer",
    contacts: [
      { label: "Name", value: "Mr. Yash" },
      { label: "Phone", value: "+91 8655661094", href: "tel:+918655661094" },
      { label: "Email", value: "nodal@ampirefinance.com", href: "mailto:nodal@ampirefinance.com" },
    ],
    resolution:
      "The Nodal officer shall ensure the disposal of the complaints within 30 days from the date of raising the Complaint by the Customer",
  },
];

const GrievanceRedressalMechanism = () => {
  return (
    <div className="page_wrapper grievance-mechanism-page-wrapper">
      <div className="grievance-mechanism-page">
        <div className="grievance-mechanism-container">
          <div className="grievance-mechanism-header">
            <span className="grievance-mechanism-icon">📋</span>
            <h1>Grievance Redressal Mechanism</h1>
            <p>
              Snap Paisa follows a structured escalation process to address customer grievances promptly and fairly.
            </p>
          </div>

          <div className="grievance-mechanism-content">
            <div className="grievance-table-wrapper">
              <table className="grievance-table">
                <thead>
                  <tr>
                    <th>Escalation Level</th>
                    <th>Department / Role</th>
                    <th>Contact Details</th>
                    <th>Resolution Timeline / Instructions</th>
                  </tr>
                </thead>
                <tbody>
                  {escalationLevels.map((item) => (
                    <tr key={item.level}>
                      <td data-label="Escalation Level">
                        <strong>{item.level}</strong>
                      </td>
                      <td data-label="Department / Role">{item.department}</td>
                      <td data-label="Contact Details">
                        <ul className="contact-list">
                          {item.contacts.map((contact) => (
                            <li key={`${item.level}-${contact.label}`}>
                              <strong>{contact.label}:</strong>{" "}
                              {contact.href ? (
                                <a href={contact.href}>{contact.value}</a>
                              ) : (
                                contact.value
                              )}
                            </li>
                          ))}
                        </ul>
                      </td>
                      <td data-label="Resolution Timeline / Instructions">{item.resolution}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GrievanceRedressalMechanism;
